export const MODAL_TYPE = {
    EDIT: 'edit',
    NOTE: 'note',
    DEFAULT: 'default'
}